import { createContext, useContext, type ReactNode } from 'react'

const ManageAccountReadOnlyContext = createContext(false)

export function ManageAccountReadOnlyProvider({
  value,
  children
}: {
  value: boolean
  children: ReactNode
}) {
  return (
    <ManageAccountReadOnlyContext.Provider value={value}>
      {children}
    </ManageAccountReadOnlyContext.Provider>
  )
}

/** True when Manage Account is opened in view-only mode (e.g. super admin on another tenant). */
export function useManageAccountReadOnly(): boolean {
  return useContext(ManageAccountReadOnlyContext)
}
